import script from "./TclScanReceive.vue?vue&type=script&setup=true&lang=js"
export * from "./TclScanReceive.vue?vue&type=script&setup=true&lang=js"

import "./TclScanReceive.vue?vue&type=style&index=0&id=7d3a6ae7&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3a6ae7"]])

export default __exports__